import React from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import Hero from '../Hero'
import AboutSection from '../AboutSection'
import SolutionsSection from '../SolutionsSection'
import HomeProduct from '../HomeProduct'
import ThreatLandscape from '../ThreatLandscape'
import WhyChoose from '../WhyChoose'
import FAQ from '../FAQ'



const Home = () => {
  return (
    <>
      <Header/>

         <Hero/>
         <AboutSection/>
         <SolutionsSection/>
         <HomeProduct/>
         <ThreatLandscape/>
         <WhyChoose/>
         <FAQ/>
            
      <Footer/>
    </>
  )
}

export default Home